export const STORAGE_ASSET_URLS = {
  logo: 'https://ijnihtbhlodmnmajwnbu.supabase.co/storage/v1/object/public/images/library/logo.jpg',
  heroBg: 'https://ijnihtbhlodmnmajwnbu.supabase.co/storage/v1/object/public/images/library/hero-bg.svg',
  familyImage1:
    'https://ijnihtbhlodmnmajwnbu.supabase.co/storage/v1/object/public/images/library/Vakuutuslaskuri-family-image-1.png',
  familyImage2:
    'https://ijnihtbhlodmnmajwnbu.supabase.co/storage/v1/object/public/images/library/Vakuutuslaskuri-family-image-2.png',
  familyImage3:
    'https://ijnihtbhlodmnmajwnbu.supabase.co/storage/v1/object/public/images/library/Vakuutuslaskuri-family-image-3.png',
  familyImage8:
    'https://ijnihtbhlodmnmajwnbu.supabase.co/storage/v1/object/public/images/library/Vakuutuslaskuri-family-image-8.png',
} as const;
